var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _path3, _path4, _path5, _path6, _rect7, _path7, _rect8, _path8, _rect9, _rect10, _rect11, _rect12, _rect13, _path9, _path10, _path11, _path12, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle89, _rect14, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnBlueFullClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 327,
    viewBox: "0 -10 87 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22559,
    y: 205.133,
    width: 85,
    height: 7,
    rx: 3.5,
    fill: "#00253F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.22559,
    y: 74.1328,
    width: 85,
    height: 7,
    rx: 3.5,
    fill: "#00253F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 199.737,
    width: 86.7543,
    height: 10.0877,
    rx: 4,
    fill: "#9F9F9F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2281,
    y: 199.662,
    width: 34.2982,
    height: 10.0877,
    fill: "#797979",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 68.5972,
    width: 86.7543,
    height: 10.0877,
    rx: 4,
    fill: "#9F9F9F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2281,
    y: 68.5972,
    width: 34.2982,
    height: 10.0877,
    fill: "#797979",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2631 4.1748L55.7544 4.03494L54.4736 266.309L48.4209 274.386L38.3332 274.386L32.2806 266.315L30.2631 4.1748Z",
    fill: "#C6EDFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.209 265.5L32.6968 178H53.6968L53.1846 265.5L46.526 274H39.8675L33.209 265.5Z",
    fill: "#00116B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 265,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 265,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 265,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 265,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 268,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 271,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 271,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 268,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 268,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 262,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 262,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 262,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 262,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 262,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 247,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 253,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 259,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 256,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 250,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 250,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 250,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 250,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 250,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 244,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 244,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 244,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 244,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 244,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 241,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 238,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 238,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 238,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 238,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 238,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 235,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 232,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 232,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 232,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 232,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 232,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 229,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 226,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 226,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 226,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 226,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 226,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 256,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 256,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 256,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 256,
    r: 1.5,
    fill: "#F5F7F9",
    stroke: "#84BE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2631 4.17529L55.7544 4.03543L54.4736 266.309L48.4209 274.386L38.3332 274.386L32.2806 266.316L30.2631 4.17529Z",
    fill: "#C6EDFC",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.2456 2.1945e-08L58.5087 0V6.05263L28.2456 6.05263L28.2456 2.1945e-08Z",
    fill: "#D3F0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.6946 110.965H56.9079V117.017H29.6946V110.965Z",
    fill: "#D3F0FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 274.386H48.4211L46.4035 284.474H40.3509L38.3334 274.386Z",
    fill: "#C6EDFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3159,
    y: 284.474,
    width: 14.1228,
    height: 4.03508,
    fill: "#C6EDFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4209 284.474L52.456 282.456V290.526L48.4209 288.509V284.474Z",
    fill: "#C6EDFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4562,
    y: 282.456,
    width: 4.03508,
    height: 8.07017,
    fill: "#C6EDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3159 288.509L34.2984 290.526L34.2984 282.456L36.3159 284.474L36.3159 288.509Z",
    fill: "#C6EDFC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2985,
    y: 290.526,
    width: 2.01754,
    height: 8.07017,
    transform: "rotate(-180 34.2985 290.526)",
    fill: "#C6EDFC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4912,
    y: 284.474,
    width: 6.05263,
    height: 4.03508,
    fill: "#93BDCD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5262,
    y: 282.456,
    width: 8.07017,
    height: 8.07017,
    fill: "#2D944A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2631,
    y: 284.474,
    width: 2.01754,
    height: 4.03508,
    fill: "#3FB25F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1755,
    y: 280.438,
    width: 6.05263,
    height: 12.1053,
    fill: "#3FB25F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2281 280.438L30.2632 284.474V288.509L26.2281 292.544V280.438Z",
    fill: "#3FB25F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2631 284.474L26.228 280.438V292.544L30.2631 288.509V284.474Z",
    fill: "#22803C",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3508 287.5H46.4035V326.842H44.3859L40.3508 314.737V287.5Z",
    fill: "#C6EDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3771 304.648L46.4035 326.841H44.3859L40.3508 314.736L43.3771 304.648Z",
    fill: "#6698AB"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04377,
    cy: 73.6401,
    r: 3.02631,
    fill: "#797878"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.05245,
    cy: 72.6313,
    r: 2.01754,
    fill: "#D1D1D1"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.7103,
    cy: 73.6401,
    r: 3.02631,
    fill: "#797878"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.7193,
    cy: 72.6313,
    r: 2.01754,
    fill: "#D1D1D1"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04377,
    cy: 204.78,
    r: 3.02631,
    fill: "#797878"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.05245,
    cy: 203.771,
    r: 2.01754,
    fill: "#D1D1D1"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.7103,
    cy: 204.78,
    r: 3.02631,
    fill: "#797878"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.7193,
    cy: 203.771,
    r: 2.01754,
    fill: "#D1D1D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2631 6.05225H38.3332V274.385L32.2806 266.315L30.2631 6.05225Z",
    fill: "#B1D8E8",
    fillOpacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4823 6.05225H48.4209V274.385L54.4735 266.315L55.4823 6.05225Z",
    fill: "#B1D8E8",
    fillOpacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.2456 2.1945e-08L58.5087 0V6.05263L28.2456 6.05263L28.2456 2.1945e-08Z",
    fill: "#E4F8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.2456 2.1945e-08L36.3158 0V6.05263L28.2456 6.05263L28.2456 2.1945e-08Z",
    fill: "#BEE1EE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M50.4387 2.1945e-08L58.5089 0V6.05263L50.4387 6.05263L50.4387 2.1945e-08Z",
    fill: "#BEE1EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.2631 6.05225L55.7507 6.05225V10.0873H30.3182L30.2631 6.05225Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.7486 110.965H56.8958V117.017H29.7479L29.7486 110.965Z",
    fill: "#E4F8FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.7036 110.965H36.3157V117.017H29.7035L29.7036 110.965Z",
    fill: "#C4E4F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M50.4387 110.965H56.9116V117.017H50.4386L50.4387 110.965Z",
    fill: "#C4E4F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.1272 117.017H55.1987V121.052H31.1695L31.1272 117.017Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.2147 254.21H55.5439L55.4824 260.263H31.2712L31.2147 254.21Z",
    fill: "#E4F8FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.272 254.21H36.3158L36.3056 260.263H31.2813L31.272 254.21Z",
    fill: "#C8E7F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M50.4387 254.21H55.4826L55.4724 260.263H50.4481L50.4387 254.21Z",
    fill: "#C8E7F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M32.2334 260.263H54.4736V264.298H32.2807L32.2334 260.263Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5923 195.524C60.6151 193.4 58.9115 191.676 56.7872 191.672L52.5636 191.666L52.4559 201.666L54.3717 201.669C57.7706 201.674 60.5557 198.923 60.5923 195.524V195.524Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2696 213.607C26.2467 211.483 27.9503 209.759 30.0746 209.755L34.2982 209.749L34.4059 219.749L32.4901 219.752C29.0912 219.757 26.3061 217.006 26.2696 213.607V213.607Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5923 213.607C60.6151 211.483 58.9115 209.759 56.7872 209.755L52.5636 209.749L52.4559 219.749L54.3717 219.752C57.7706 219.757 60.5557 217.006 60.5923 213.607V213.607Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2696 195.524C26.2467 193.4 27.9503 191.676 30.0746 191.672L34.2982 191.666L34.4059 201.666L32.4901 201.669C29.0912 201.674 26.3061 198.923 26.2696 195.524V195.524Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5923 64.459C60.6151 62.3348 58.9115 60.6101 56.7872 60.6068L52.5636 60.6002L52.4559 70.6004L54.3717 70.6034C57.7706 70.6087 60.5557 67.8578 60.5923 64.459V64.459Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2696 82.542C26.2467 80.4178 27.9503 78.6931 30.0746 78.6898L34.2982 78.6832L34.4059 88.6834L32.4901 88.6864C29.0912 88.6917 26.3061 85.9408 26.2696 82.542V82.542Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5923 82.542C60.6151 80.4178 58.9115 78.6931 56.7872 78.6898L52.5636 78.6832L52.4559 88.6834L54.3717 88.6864C57.7706 88.6917 60.5557 85.9408 60.5923 82.542V82.542Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2696 64.459C26.2467 62.3348 27.9503 60.6101 30.0746 60.6068L34.2982 60.6002L34.4059 70.6004L32.4901 70.6034C29.0912 70.6087 26.3061 67.8578 26.2696 64.459V64.459Z",
    fill: "white"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5617,
    cy: 286.54,
    r: 1.85821,
    fill: "#3FB25F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5265,
    y: 290.576,
    width: 8.07017,
    height: 8.07017,
    transform: "rotate(-90 60.5265 290.576)",
    fill: "#93BDCD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4386 288.558C51.334 288.558 50.4386 287.645 50.4386 286.541V286.541C50.4386 285.436 51.334 284.523 52.4386 284.523H58.5088V288.558H52.4386Z",
    fill: "#3FB35F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6847 284.523C77.7893 284.523 78.6847 285.436 78.6847 286.54V286.54C78.6847 287.645 77.7893 288.558 76.6847 288.558L70.6145 288.558L70.6145 284.523L76.6847 284.523Z",
    fill: "#3FB35F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5089 288.558V284.523L60.5265 282.506V290.576L58.5089 288.558Z",
    fill: "#22803C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6149 284.523L70.6149 288.558L68.5973 290.576L68.5973 282.505L70.6149 284.523Z",
    fill: "#22803C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnBlueFullClosed);
export default __webpack_public_path__ + "static/media/column-blue-full-closed.313d45af7876a15bcff3bed977e01314.svg";
export { ForwardRef as ReactComponent };